import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import ResponsiveForm from '../../Form';
import { validate } from '../../../../Helpers';
import {
  BANK_FORM as form,
  BANK_VALIDATIONS,
  EDIT_INPUTS,
} from './config';

let EditBankForm = ({ handleSubmit, loading = false, ...props }) => (
  <ResponsiveForm
    {...props}
    inputs={EDIT_INPUTS}
    loading={loading}
    onSubmit={handleSubmit}
  />
);

EditBankForm = reduxForm({
  form,
  validate: validate(BANK_VALIDATIONS),
})(EditBankForm);

const mapStateToProps = ({
  banks: {
    item,
  },
}) => ({
  initialValues: item ? item.data : {},
});

export default connect(
  mapStateToProps
)(EditBankForm);
